export function formatPrice(value: number): string {
  return value.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
}

export function formatWhatsAppNumber(raw: string): string {
  return raw.replace(/\D/g, '');
}

export function buildWhatsAppMessage(
  businessName: string,
  items: { product: { name: string; price: number }; quantity: number }[]
): string {
  const lines = items.map(
    (item, i) =>
      `${i + 1}. ${item.product.name} — ${item.quantity}x — ${formatPrice(
        item.product.price * item.quantity
      )}`
  );
  const total = items.reduce((sum, i) => sum + i.product.price * i.quantity, 0);
  return (
    `*Novo Pedido — ${businessName}*\n\n` +
    lines.join('\n') +
    `\n\n*Total: ${formatPrice(total)}*`
  );
}

export function buildWhatsAppUrl(
  number: string,
  message: string
): string {
  return `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
}

export function normalizePublicImageUrl(rawUrl: string): string {
  const value = rawUrl.trim();
  if (!value || typeof window === 'undefined') return value;

  try {
    if (value.startsWith('/uploads/')) {
      return `${window.location.origin}${value}`;
    }

    if (value.startsWith('uploads/')) {
      return `${window.location.origin}/${value}`;
    }

    const parsed = new URL(value, window.location.origin);
    const isLocalHost = ['localhost', '127.0.0.1', '::1'].includes(parsed.hostname);
    const uploadsIndex = parsed.pathname.lastIndexOf('/uploads/');

    if (isLocalHost && uploadsIndex >= 0) {
      const uploadsPath = parsed.pathname.slice(uploadsIndex);
      return `${window.location.origin}${uploadsPath}`;
    }

    return parsed.toString();
  } catch {
    return value;
  }
}
